module.exports = __webpack_public_path__ + "media/images/welcome_page_quizzes-a98038cf465ddb1a5e0f30e288e79117.png";